import React from 'react';
import { secondsIntoHoursMinutes } from 'utils/formating';

export default function Duration({ className, seconds }: any) {
  return (
    <time dateTime={`P${Math.round(seconds)}S`} className={className}>
      {secondsIntoHoursMinutes(seconds)}
    </time>
  );
}
